module.exports = __webpack_public_path__ + "static/media/logo-m.fcb703b7.png";